<template>
  <div class="tms-header">
    <div
      class="tms-header__box"
      :class="{'tms-header__box-fullscreen': fullScreen}"
    >
      <div class="tms-header-top">
        <div class="tms-header-back-slot">
          <slot name="back-button">
            <span
              v-if="needGoback"
              class="back"
              @click="_goback"
            >
              &lt; {{ $t('back') }}
            </span>
          </slot>
        </div>
        <div
          v-if="needRightTop"
          class="tms-header__right-top"
        >
          <slot name="right-top">
            <span>right-top</span>
          </slot>
        </div>
      </div>
      <div class="content">
        <div class="main-title">
          <div class="title">
            {{ title }}
            <dotted-dropdown
              v-if="showDotOption"
              id="tenant-tms-header"
            >
              <li
                v-for="(item, index) in dotOption"
                :key="index"
              >
                <a
                  class="dot-option-btn"
                  @click="() => item.operate && _operate(item)"
                >
                  {{ item.title }}
                </a>
              </li>
            </dotted-dropdown>
          </div>
        </div>
        <div class="clearfix">
          <div class="tms-header-status-row">
            <slot name="status">
              <div
                v-if="status"
                :class="statusStyle"
                @click="openLifecycleModal()"
              >
                <span>{{ status|customStatusLabel }}</span>
              </div>
            </slot>
            <div
              v-if="helpFunc"
              class="help"
              @click="() => helpFunc()"
            >
              {{ $t('workPermit.help') }}
            </div>
            <slot name="status-detail" />
          </div>
          <Sticky
            :extendStickyClass="extendStickyClass"
            :zIndex="110"
            align="right"
            :stickyTop="40"
            specifyWidth="auto"
          >
            <div class="button-groups">
              <slot name="before-buttons" />
              <button
                v-for="(btn, index) in buttons"
                :key="index"
                :class="['btn', btn.cls]"
                :disabled="btn.disable"
                @click="() => btn.func && _btnOperation(btn)"
              >
                {{ btn.title }}
              </button>
            </div>
          </Sticky>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import lodash from 'lodash'

import DottedDropdown from '@/controls/DottedDropdown'
import Sticky from '@/controls/Sticky'

export default {
  name: 'TMSHeader',
  components: {
    DottedDropdown,
    Sticky,
  },
  props: {
    // [{title, cls, func}]
    buttons: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: '',
    },
    goBack: {
      type: [Function, String],
      default: '',
    },
    status: {
      type: String,
      default: '',
    },
    dotOption: {
      type: Array,
      default: () => [],
    },
    needGoback: {
      type: Boolean,
      default: true,
    },
    needRightTop: {
      type: Boolean,
      default: false,
    },
    fullScreen: {
      type: Boolean,
      default: false,
    },
    extendStickyClass: {
      type: String,
      default: '',
    },
    lifecycleModal: {
      type: Function,
    },
    helpFunc: {
      type: Function,
    },
  },
  computed: {
    showDotOption () {
      return this.dotOption.length
    },
    statusStyle () {
      const lowerCasestatus = lodash.kebabCase(this.status.toLowerCase())
      return `tenant-project-status-${lowerCasestatus} tenant-project-status float-left ${this.pointerClass}`
    },
  },
  methods: {
    _operate (item) {
      document.body.focus()
      item.operate()
    },
    _btnOperation (btn) {
      // change document.activeElement
      document.body.focus()
      btn.func()
    },
    _goback () {
      this.goBack ? this.goBack() : this.$router.goBack()
    },
    openLifecycleModal () {
      if (this.lifecycleModal) {
        this.lifecycleModal()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/tender/common';

.tms-header {
  background: #ffffff;
  box-shadow: 0 0 4px 0 rgba(172, 172, 172, 0.5);
  min-height: 115px;
  &__box {
    max-width: 1440px;
    margin: 0 auto;
    padding: 18px 0px;
    position: relative;
    &-fullscreen {
      max-width: 100%;
    }
  }
  &-top {
    display: flex;
    justify-content: space-between;
  }
  &-back-slot {
    flex: 1;
    min-width: 0;
  }
  .back {
    font-family: Verdana;
    font-size: 14px;
    color: #0C3A58;
    cursor: pointer;
  }
  .content {
    margin-top: 5px;
    &:after {
      content: "";
      display: block;
      height: 0;
      clear: both;
      visibility: hidden;
    }
  }
  .button-groups {
    float: right;
    button + button {
      margin-left: 15px;
    }
  }
  .tms-header-status-row {
    align-items: center;
    display: flex;
    float: left;
    min-height: 35px;
  }
  .main-title {
    font-size: 24px;
    font-weight: bold;
    font-family: Georgia;
    display: flex;
    align-items: center;
    .title {
      margin: 0;
      font-size: 24px;
      line-height: 40px;
      #tenant-tms-header {
        display: inline-block;
        height: 25px;
      }
    }
  }
  .dot-option-btn {
    text-decoration: none;
  }

  .help {
    text-decoration: underline;
    font-style: italic;
    line-height: 20px;
    padding: 0 10px;
    cursor: pointer;
  }
}
</style>
